export default __webpack_public_path__ + "static/media/Magazine2.1f29d2a8.png";